import { Injectable } from '@angular/core';
import { Http,  Headers } from '@angular/http';
import { ConfigService } from '@shared/utils/config.service';
import { BaseService } from "./base.service";
import { Observable } from 'rxjs/Rx';

import '../../rxjs-operators';

@Injectable({
    providedIn: 'root', // <---- Adiciona isto ao serviço
  })

export class PrevisaoVendasService extends BaseService {

    baseUrl: string = "";

    constructor(private http: Http, private configService: ConfigService) {
        super();

        this.baseUrl = configService.getApiURI();
    }

    getSetting(){

    }

    getVersaoBack(): Observable<any>{
        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        return this.http
          .get(`${this.baseUrl}/alertas/getVersaoBack`)
          .catch(this.handleError);
    }

    getDaysToClose():Observable<any> {

        console.log("Chamando Back-end")

        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        return this.http
          .get(`${this.baseUrl}/vendas/getDaysToClose`)
          .catch(this.handleError);
    
    }

}
